module.exports = __webpack_public_path__ + "img/recruitBanner.27fce31c.jpeg";